var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "mt-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Préférences de documents d‘achat")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des données")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Les informations que vous choisissez d'afficher sur vos documents seront également affichées sur les documents de vos collaborateurs n'ayant pas accès aux préférences générales."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.document,
            callback: function($$v) {
              _vm.document = $$v
            },
            expression: "document"
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col span_6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "identity" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Mon identité (prénom et nom)")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "email" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Mon adresse email")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "phone" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Mon numéro de ligne directe")))
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col span_6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "mobile" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Mon numéro de portable")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "fax" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Mon numéro de fax")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "address" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Mon adresse")))
                  ])
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Vous pouvez ensuite modifier ces préférences lors de l'édition de documents"
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des colonnes")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Les mentions que vous souhaitez afficher ou non par défaut sur vos documents pourront être réglées en fonction de vos clients (dans les préférences de chacun de vos clients) et pour chaque document."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.column,
            callback: function($$v) {
              _vm.column = $$v
            },
            expression: "column"
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col span_6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "reference" } }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Afficher la colonne Référence"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "description" } }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Afficher la colonne Description"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "unit" } }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Afficher la colonne prix unitaire"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "vat" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne TVA")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "quantity" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Quantité")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "payment" } }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Afficher les infos de Paiement"))
                    )
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col span_6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "totals" } }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Afficher les totaux du document"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "taxes" } }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Afficher les taxes du document"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "taxFree" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Montant")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "image" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Image")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "discount" } }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Remise")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("el-checkbox", { attrs: { label: "expireDate" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$l10n.__("Afficher la date de livraison estimée")
                      )
                    )
                  ])
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des informations produits")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.catalog,
            callback: function($$v) {
              _vm.catalog = $$v
            },
            expression: "catalog"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "number" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le nombre de produits du document sur le PDF"
                    )
                  )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des informations fournisseur")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.third,
            callback: function($$v) {
              _vm.third = $$v
            },
            expression: "third"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "contact" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le nom du contact fournisseur sur le PDF"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "reference" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher la référence du fournisseur sur le document"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "signatureOnOrder" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher la signature sur les bons de commandes fournisseur"
                    )
                  )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Informations de livraison")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-level mt-3" },
        [
          _c("span", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Temps de livraison par défaut")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("el-input-number", {
            staticClass: "dinlineb mx-2 input-small",
            attrs: { min: 1 },
            model: {
              value: _vm.deliveryDelay,
              callback: function($$v) {
                _vm.deliveryDelay = $$v
              },
              expression: "deliveryDelay"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$l10n.__("jour(s)")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Informations de paiement")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.payment,
            callback: function($$v) {
              _vm.payment = $$v
            },
            expression: "payment"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "delay" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Afficher le délai de règlement")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "deadline" } }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Afficher la date limite de règlement"))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "means" } }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Afficher les moyens de règlements"))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "deposit" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Afficher le détail de l‘acompte")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.save($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }